export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-m.b3690f3c.png";